import { render, staticRenderFns } from "./TaskMoneyConfigpddfjsp.vue?vue&type=template&id=2157b9e8&"
import script from "./TaskMoneyConfigpddfjsp.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigpddfjsp.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigpddfjsp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports